<template>
    <div class="component-settings-user-detail">
        <div class="row">
            <div class="col-12" :style="$store.state.general.settingsMenuMode === 'vertical' ? {'padding': '0px'} : {}">
                <div class="el-card__header text-left" slot="header" style=" border: 1px solid #EBEEF5">
                    <div class="row center-align-vert">
                        <div class="col-6 center-align-vert">
                            <el-button @click="$router.push({ 'name': 'settings-users'})" class="inline fl mr-10" icon="el-icon-back"></el-button>
                            <avatar :lighten="100" :username="form['first_name'] + ' ' + form['last_name']" :size="35"></avatar>
                        </div>
                        <div class="col-6 fr">
                            <el-button class="fr ml-10" type="primary" @click="submit" @submit.prevent="submit">Save</el-button>
                            <el-button class="fr" type="danger" v-if="this.nonEdit.includes('is_superuser') === false" @click="openWarning" @submit.prevent="submit">Delete</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <h5 class="title-left-bold">User details</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never"  v-if="loaded">
                        <div class="row">
                            <div class="col-12">
                                <el-form ref="form" :model="form" label-width="120px">
                                    <el-form-item label="First name">
                                        <el-input :disabled="nonEdit.includes('email')" v-model="form.first_name"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Last name">
                                        <el-input :disabled="nonEdit.includes('email')" v-model="form.last_name"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Active" class="text-left">
                                        <el-switch :disabled="nonEdit.includes('email')" v-model="form.active"></el-switch>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
            <div class="row" v-if="this.nonEdit.includes('roles') === false">
                <div class="col-12">
                    <h5 class="title-left-bold mt-50">User roles</h5>
                </div>
            </div>
            <div class="row" v-if="this.nonEdit.includes('roles') === false">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never"  v-if="loaded">
                        <div class="row">
                            <div class="col-12">
                                <el-form ref="form" :model="form" label-width="120px">
                                    <el-form-item class="user-roles">
                                        <el-checkbox-group v-model="checkedRoles">
                                            <el-checkbox style="display: block" v-for="role in roles" :key="role.level" :label="role.label"></el-checkbox>
                                        </el-checkbox-group>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import Avatar from 'vue-avatar'
import { getHeadersWithAccessToken, formatString } from '../../functions.js'
export default {
    data () {
        return {
            form: {},
            roles: {},
            checkedRoles: [],
            loaded: false,
            nonEdit: []
        }
    },
    components: {
        Avatar
    },
    methods: {
        openWarning () {
            this.$confirm('This will permanently delete this user. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteUser()
            }).catch(() => {
            //
            })
        },
        submit () {
            this.form.roles = []
            for (let role of this.checkedRoles) {
                this.form.roles.push(this.roles.find(x => x.label === role).level)
            }
            axios.put(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user?user_id=' + this.$route.query.user_id, this.form, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.$router.push({ 'name': 'settings-users', 'params': { 'update': true, 'delete': false, 'user_id': this.$route.query.user_id } })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        deleteUser () {
            axios.delete(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user?user_id=' + this.$route.query.user_id, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.$router.push({ 'name': 'settings-users', 'params': { 'update': false, 'delete': true, 'user_id': this.$route.query.user_id } })
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created () {
        axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/roles?user_id=' + this.$route.query.user_id, { 'headers': getHeadersWithAccessToken() })
            .then(response => {
                this.roles = []
                for (let item of response.data.data) {
                    item['label'] = formatString(item.name)
                    this.roles.push(item)
                }
                axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/user?user_id=' + this.$route.query.user_id, { 'headers': getHeadersWithAccessToken() })
                    .then(response => {
                        this.nonEdit = response.data.non_edit
                        this.form = response.data.data
                        for (let item of this.form.roles) {
                            try { // try needed if roles are removed later on but still in user details
                                this.checkedRoles.push(this.roles.find(x => x.level === item).label)
                            } catch {
                                //
                            }
                        }
                        this.loaded = true
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
            .catch(error => {
                console.log(error)
            })
    }
}
</script>

<style lang="scss">
.component-settings-user-detail {
    p {
        margin-bottom: 0px;
    }
    .el-card__body {
        padding-bottom: 0px !important;
    }
    .el-input__inner {
        float: left;
        max-width: 250px !important;
    }
    .user-roles {
        .el-form-item__content {
            margin-left: 70px !important;
        }
    }
    .el-checkbox__inner {
        height: 21px !important;
        width: 21px !important;
    }
    .el-checkbox__inner::after {
        height: 10.5px;
        left: 7px;
        width: 4.5px;
    }
}
</style>
